import { Checkbox } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

export const SelectAllCheckbox = ({
  options,
  selectedOptions,
  optionComparer,
  onChange
}) => {
  const someOptionsSelected = selectedOptions.length > 0;
  const areAllSelected =
    someOptionsSelected &&
    (options?.every(option =>
      selectedOptions.some(selectedOption =>
        optionComparer(option, selectedOption)
      )
    ) ??
      false);

  return (
    <Checkbox
      color="primary"
      indeterminate={someOptionsSelected && !areAllSelected}
      checked={areAllSelected}
      onChange={onChange}
      size="small"
    />
  );
};

SelectAllCheckbox.propTypes = {
  /* The full list of options */
  options: PropTypes.array.isRequired,
  /* The currently selected options */
  selectedOptions: PropTypes.array.isRequired,
  /* A function to check if two options are equal */
  optionComparer: PropTypes.func.isRequired,
  /* Callback fired when checkbox value is changed */
  onChange: PropTypes.func.isRequired
};
